import _toConsumableArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _createClass from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty"; ///////////////////////////////////////////////////////////
// ReflexSplitter
// By Philippe Leefsma
// December 2016
//
///////////////////////////////////////////////////////////

import { Browser, getDataProps } from './utilities';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import React from 'react';

var ReflexSplitter =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ReflexSplitter, _React$Component);

  _createClass(ReflexSplitter, null, [{
    key: "isA",
    /////////////////////////////////////////////////////////
    //
    //
    /////////////////////////////////////////////////////////
    value: function isA(element) {
      if (!element) {
        return false;
      } //https://github.com/leefsmp/Re-Flex/issues/49


      return process.env.NODE_ENV === 'development' ? element.type === React.createElement(ReflexSplitter, null).type : element.type === ReflexSplitter;
    } /////////////////////////////////////////////////////////
    //
    //
    /////////////////////////////////////////////////////////

  }]);

  function ReflexSplitter(props) {
    var _this;

    _classCallCheck(this, ReflexSplitter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReflexSplitter).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onMouseMove", function (event) {
      if (_this.state.active) {
        _this.props.events.emit('resize', {
          index: _this.props.index,
          event: event
        });

        if (_this.props.onResize) {
          _this.props.onResize({
            domElement: ReactDOM.findDOMNode(_assertThisInitialized(_this)),
            component: _assertThisInitialized(_this)
          });
        }

        event.stopPropagation();
        event.preventDefault();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (event) {
      _this.setState({
        active: true
      });

      if (_this.props.onStartResize) {
        // cancels resize from controller
        // if needed by returning true
        // to onStartResize
        if (_this.props.onStartResize({
          domElement: ReactDOM.findDOMNode(_assertThisInitialized(_this)),
          component: _assertThisInitialized(_this)
        })) {
          return;
        }
      }

      _this.props.events.emit('startResize', {
        index: _this.props.index,
        event: event
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseUp", function (event) {
      if (_this.state.active) {
        _this.setState({
          active: false
        });

        if (_this.props.onStopResize) {
          _this.props.onStopResize({
            domElement: ReactDOM.findDOMNode(_assertThisInitialized(_this)),
            component: _assertThisInitialized(_this)
          });
        }

        _this.props.events.emit('stopResize', {
          index: _this.props.index,
          event: event
        });
      }
    });

    _this.state = {
      active: false
    };
    _this.document = props.document;
    return _this;
  } /////////////////////////////////////////////////////////
  //
  //
  /////////////////////////////////////////////////////////


  _createClass(ReflexSplitter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.document) {
        return;
      }

      this.document.addEventListener('touchend', this.onMouseUp);
      this.document.addEventListener('mouseup', this.onMouseUp);
      this.document.addEventListener('mousemove', this.onMouseMove, {
        passive: false
      });
      this.document.addEventListener('touchmove', this.onMouseMove, {
        passive: false
      });
    } /////////////////////////////////////////////////////////
    //
    //
    /////////////////////////////////////////////////////////

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this.document) {
        return;
      }

      this.document.removeEventListener('mouseup', this.onMouseUp);
      this.document.removeEventListener('touchend', this.onMouseUp);
      this.document.removeEventListener('mousemove', this.onMouseMove);
      this.document.removeEventListener('touchmove', this.onMouseMove);

      if (this.state.active) {
        this.props.events.emit('stopResize', {
          index: this.props.index,
          event: null
        });
      }
    } /////////////////////////////////////////////////////////
    //
    //
    /////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////
    //
    //
    /////////////////////////////////////////////////////////

  }, {
    key: "render",
    value: function render() {
      var className = [Browser.isMobile() ? 'reflex-thin' : ''].concat(_toConsumableArray(this.props.className.split(' ')), [this.state.active ? 'active' : '', 'reflex-splitter']).join(' ').trim();
      return React.createElement("div", _extends({}, getDataProps(this.props), {
        onTouchStart: this.onMouseDown,
        onMouseDown: this.onMouseDown,
        style: this.props.style,
        className: className,
        id: this.props.id
      }), this.props.children);
    }
  }]);

  return ReflexSplitter;
}(React.Component);

export { ReflexSplitter as default };

_defineProperty(ReflexSplitter, "propTypes", {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  onStartResize: PropTypes.func,
  onStopResize: PropTypes.func,
  className: PropTypes.string,
  propagate: PropTypes.bool,
  onResize: PropTypes.func,
  style: PropTypes.object /////////////////////////////////////////////////////////
  //
  //
  /////////////////////////////////////////////////////////

});

_defineProperty(ReflexSplitter, "defaultProps", {
  document: typeof document !== 'undefined' ? document : null,
  onStartResize: null,
  onStopResize: null,
  propagate: false,
  onResize: null,
  className: '',
  style: {} /////////////////////////////////////////////////////////
  // Determines if element is a splitter
  // or wraps a splitter
  //
  /////////////////////////////////////////////////////////

});